@if (control) {
<div class="text-area-input basic-input tw-box-border tw-font-inter" style="padding: 5px 0 25px">
  <div class="tw-relative tw-group">
    <textarea
      #textarea
      (paste)="preventExceedingMaxCharactersOnPaste($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [ngClass]="{
        '!tw-border-red-600 dark:!tw-border-red-500 hover:!tw-border-red-700': control.invalid && !control.disabled && control.touched,
        '!tw-border-green-600 dark:!tw-border-green-500 hover:!tw-border-green-700': control.valid && !control.disabled && !!control.value && control.touched,
        'tw-px-9': icon,
        'tw-pb-8': counter,
        'placeholder:tw-text-gray-300 dark:placeholder:!tw-text-gray-400': control.value || (!control.value && control.touched && !control.validator)
      }"
      [formControl]="control"
      [id]="id"
      [rows]="rows"
      class="tw-bg-transparent tw-outline-none tw-font-inter placeholder:tw-text-gray-500 dark:placeholder:!tw-text-gray-400 tw-px-4 placeholder:tw-text-sm tw-w-full focus:tw-ring-0 tw-text-sm tw-text-gray-900 dark:tw-text-white tw-font-medium tw-leading-[21px] peer tw-py-5 tw-min-h-[58px] tw-rounded-lg tw-box-border tw-border tw-border-gray-300 dark:tw-border-gray-600 tw-cursor-auto hover:tw-border-blue-700 dark:hover:tw-border-blue-600 focus:tw-border-2 focus:tw-border-blue-600 dark:focus:tw-border-blue-500 focus:tw-shadow-none"
      [placeholder]="placeholder || label"
    ></textarea>
    @if (icon) {
    <span
      [innerHTML]="sanitizeSVG(icon)"
      class="input-icon tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-left-3 tw-flex tw-items-center"
      [ngClass]="{
        'fill-icon': iconType === 'fill',
        'stroke-icon': iconType === 'stroke'
      }"
    ></span>
    }
    <label
      [for]="id"
      class="tw-absolute tw-text-sm tw-cursor-text tw-font-medium tw-leading-[21px] tw-select-none tw-duration-300 tw-transform tw-origin-[0] tw-z-10 tw-px-1 tw-bg-white dark:tw-bg-gray-800"
      [ngClass]="{
        'tw-text-gray-500 dark:!tw-text-gray-400': control.untouched && !control.value && !isFocused,
        'tw-text-gray-700 dark:!tw-text-gray-400': (control.untouched && control.value) || control.status === 'PENDING',
        '!tw-text-blue-700 peer-hover:!tw-text-blue-800': isFocused && !control.value && control.touched,
        '!tw-text-green-600 peer-hover:!tw-text-green-700': control.valid && !!control.value && control.touched,
        '!tw-text-red-600 dark:!tw-text-red-500 peer-hover:!tw-text-red-700': control.invalid && control.touched,
        'tw-start-9': icon && !control.value && !isFocused,
        'tw-start-2': !icon || control.value || isFocused,
        'tw-top-1 tw-scale-75 -tw-translate-y-4': control.value || control.value === 0 || isFocused,
        'tw-top-1/2 -tw-translate-y-1/2 tw-scale-100': !control.value && control.value !== 0 && !isFocused,
        'peer-focus:tw-bg-white dark:peer-focus:tw-bg-gray-800 peer-focus:tw-text-blue-700 dark:peer-focus:tw-text-blue-400 !tw-text-blue-700':
          isFocused && !control.dirty && !control.touched && !control.value
      }"
    >
      {{ label }}
    </label>
    @if (counter) {
    <span class="text-area-counter tw-absolute tw-right-2 tw-bottom-2 tw-text-gray-500 tw-text-sm">
      {{ currentCharacters }} / {{ maxCharacters }}
    </span>
    }
  </div>
</div>
}
